import "../../../FhDropdownDivider.css";
import { openBlock, createElementBlock, createVNode } from "vue";
import FhDivider from "../../FhDivider/FhDivider.mjs";
const _hoisted_1 = { class: "fh-dropdown-divider" };
const _sfc_main = {
  __name: "FhDropdownDivider",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", _hoisted_1, [
        createVNode(FhDivider, { variant: "subtle" })
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=FhDropdownDivider.mjs.map
